<app-list-page
  [headline]="
    (lastResult.totalNumberResultsets === 1 ? 'team.size.singular' : 'team.size.plural')
      | translate: { persons: lastResult.totalNumberResultsets || 0 }
  "
  [subheadline]="'team.nation' | translate: { nations: lastResult.totalCountries || 0 }"
  (downloadList)="downloadTheList()"
  [detailsLoaded]="employeeEmail ? true : false">
  <hoc-filter-block
    data-testid="team-filter-block"
    filter
    [textSearch]="searchForName"
    [statusFilterVisible]="false"
    [applyFilter]="applyNewFilter"
    (changed)="filterBlockChanged($event)"
    defaultSorting="asc"
    [filters]="filtersForBlock"></hoc-filter-block>
  <hoc-grouped-list
    data-testid="team-list"
    list
    [loading]="loading"
    [groupLetters]="groupLetters"
    [items]="items"
    [loadingBlock]="loadingBlock"
    [footerBlock]="footerBlock"
    [groupBlock]="groupBlock"
    [itemBlock]="itemBlock"
    [emptyItemsBlock]="emptyItemsBlock"
    (scrolledToEnd)="scrolledToEnd()">
  </hoc-grouped-list>
  <app-employee-details
    data-testid="team-employee-details"
    details
    (closeClicked)="closeEmployeeDetails()"
    (companySelected)="companySelected($event)"
    (locationSelected)="locationSelected($event)"
    (boardSelected)="boardSelected($event)"
    [employeeId]="employeeEmail"></app-employee-details>
</app-list-page>

<ng-template #emptyItemsBlock>
  <app-empty-list-page (backButtonClicked)="handleEmptyList()"></app-empty-list-page>
</ng-template>

<ng-template #groupBlock let-letter>
  <h3 class="list-title-text">{{ letter }}</h3>
</ng-template>

<ng-template #loadingBlock>
  <app-list-placeholder [hasTitle]="true" [hasImageColumn]="true" [columnCount]="3" [lineCount]="2" />
</ng-template>

<ng-template #itemBlock let-item>
  <app-list-item [data]="getTeamListItem(item)" (onClicked)="employeeSelected(item)"></app-list-item>
</ng-template>

<ng-template #footerBlock>
  <div #footerContainer class="px-3 py-4">
    <!-- TODO: Add a <gx-button>Load more</gx-button> also with infinite scroll. in case something is not working user has control!-->
    @if (loadMode === 'paged' && items.size > 0) {
      <gx-pagination
        data-testid="team-list-pagination"
        [data]="pagination"
        (newPage)="gotoPage($event)"
        [availablePageSizes]="config.pageSizes"
        [currentPageSize]="filter.pageSize"
        [lengthBeginSegment]="4"
        [lengthEndSegment]="4"
        (newPageSize)="newPageSize($event)" />
    }
    @if (loadMode === 'infinite' && canLoadMore) {
      <app-list-placeholder [hasImageColumn]="true" [columnCount]="3" [lineCount]="2" (click)="scrolledToEnd()" />
    }
  </div>
</ng-template>
